module.exports = __webpack_public_path__ + "static/media/touch-phone.cfc8f22b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/touch-phone.png
// module id = 369
// module chunks = 0